<template>
  <div class="row">
    <div v-if="!nalaganje">
      <div class="info-container">
        <!-- Achieved Points -->
        <info-card v-if="points/maxPoints > 0.75" :title="$t('pages.exams.ratingResults.achievvedPoints')" icon="glyphicon glyphicon-ok" iconColor="#0073b7" :value="points + '/' + maxPoints"/>
        <info-card v-else :title="$t('pages.exams.ratingResults.achievvedPoints')" icon="glyphicon glyphicon-ok" iconColor="#f39c12" :value="points + '/' + maxPoints"/>
        <!-- Rating Change -->
        <info-card :title="$t('pages.exams.ratingResults.ratingChange')" icon="glyphicon glyphicon-stats" iconColor="#0073b7" :previous="oldRating" :value="newRating"/>
        <!-- Rating Accuracy -->
        <info-card v-if="newRatingDeviation <= 70" :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#0073b7" :previous="Math.round((1 - oldRatingDeviation/350) * 100)" :value="Math.round((1 - newRatingDeviation/350) * 100) + '%'"/>
        <info-card v-else-if="newRatingDeviation <= 180" :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#f39c12" :previous="Math.round((1 - oldRatingDeviation/350) * 100)" :value="Math.round((1 - newRatingDeviation/350) * 100) + '%'"/>
        <info-card v-else :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#dd4b39" :previous="Math.round((1 - oldRatingDeviation/350) * 100)" :value="Math.round((1 - newRatingDeviation/350) * 100) + '%'"/>
      </div>
      <div class="second-container">
        <!-- View Your Answers -->
        <div class="view-your-answers-card" @click.prevent="showQuestions">
          <div>
            <i class="fa fa-list-ul" style="font-size: 50px; height: 100%; padding: 12px; color:black !important"></i>
          </div>
          <div class="info-card-content">
            <span style="font-size: 23px; font-weight: bold; color: #3a3a3a; margin: 10px 10px 10px 0">{{$t("pages.exams.ratingResults.viewYourAnswers")}}</span>
          </div>
        </div>
        <leaderboard-card v-if="latestRatingDeviation > 87.5" title="Lestvica" content="Za uvrstitev na lestvico rešite več Rating kvizov" :progress="(1-latestRatingDeviation/350)*100" />
      </div>
      <!-- Leaderboard -->
      <leaderboard :gid="gid" style="margin: 30px 0"/>
      <graph v-if="zgodovinaRatinga" :ratingHistory="zgodovinaRatinga" />
    </div>
  </div>
</template>

<script>
  import Rest from '../../services/rest'
  import InfoCard from '@/components/rating/cards/InfoCard.vue'
  import LeaderboardCard from '@/components/rating/cards/LeaderboardAccuracyCard.vue'
  import Leaderboard from '@/components/rating/cards/Leaderboard.vue'
  import Graph from '@/components/rating/cards/Graph.vue'

  export default {
    components: {
      Leaderboard,
      LeaderboardCard,
      InfoCard,
      Graph
    },
    props: {
      attemptId: '',
      gid: '',
      yid: '',
      sid: ''
    },
    data () {
      return {
        nalaganje: true,
        oldRating: -1,
        newRating: -1,
        oldRatingDeviation: -1,
        newRatingDeviation: -1,
        latestRatingDeviation: -1,
        points: -1,
        maxPoints: -1,
        ratingHistory: null,
        zgodovinaRatinga: null
      }
    },
    name: 'RatingExamResults',
    mounted () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': 'Results', sl: 'Rezultati'}}])
      this.getRatingData()
    },
    methods: {
      pripraviGraf () {
        let data = []
        for (let i = this.ratingHistory.length - 1; i >= 0; i--) {
          data.push({newRating: this.ratingHistory[i].ratingGlicko})
        }
        this.zgodovinaRatinga = data
        this.nalaganje = false
      },
      showQuestions () {
        this.$router.push({name: 'classExamResults', params: {classExamId: this.attemptId}})
      },
      getRatingData () {
        let postdata = {
          attemptId: this.attemptId,
          groupId: this.gid
        }
        return Rest.request('POST', `/rating/ratingQuizResults`, postdata).then((data) => {
          this.oldRating = data.oldRating
          this.newRating = data.newRating
          this.oldRatingDeviation = data.oldRatingDeviation
          this.newRatingDeviation = data.newRatingDeviation
          this.points = data.points
          this.maxPoints = data.maxPoints
          this.ratingHistory = data.ratingHistory
          this.latestRatingDeviation = this.ratingHistory[0].ratingDeviation
          this.pripraviGraf()
        }).catch((err) => {
          console.log(err)
          this.nalaganje = false
        })
      }
    }
  }
</script>

<style scoped>
.view-your-answers-card {
  background-color: #F8F8F8;
  display: flex;
  justify-content: space-between;
  position: relative;
  border-radius: 8px;
  padding: 25px 30px 13px 15px;
  transition: 200ms;
  cursor: pointer;
}
.view-your-answers-card:hover {
  background-color: #f5f5f5;
  transition: 200ms;
}

.info-card-content {
  text-align: right;
}
.info-container {
  margin: 30px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
}
.second-container {
  margin: 30px 0;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
}
@media (max-width: 480px) {
  .info-container {
    grid-template-columns: 100%;
  }
  .second-container {
    grid-template-columns: 100%;
  }
}

</style>


// WEBPACK FOOTER //
// RatingExamResults.vue?114709bc